import useMdBreakpoint from "@/hooks/useMdBreakpoint";
import { ArrowUpIcon } from "lucide-react";
import FramerButton from "../framer/FramerButton";

function ScrollToTopButton({scrollToTop, isVisible}: {scrollToTop: () => void, isVisible: boolean}){
  const isMdBreakpoint = useMdBreakpoint();
  // Hide button on medium and larger screens
  if(isMdBreakpoint || !isVisible) return null;

  return (
    <FramerButton
      className="fixed bottom-4 right-4 bg-mfpurple p-2 rounded-md shadow-md shadow-gray-600 dark:shadow-gray-950"
      onClick={scrollToTop}
    >
      <ArrowUpIcon className="w-6 h-6 text-white" />
    </FramerButton>
  );
}

export default ScrollToTopButton;
